class FaqAccordion {
    constructor(el, options = {}) {
        this.options = {
            multipleOpen: false,
            scrollToOpen: true,
            ...options,
        };

        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.toggle = this.root.querySelector('[data-faq-toggle]');
        this.content = this.toggle.nextElementSibling;

        return true;
    }

    init() {
        this.content.style.overflow = 'hidden';
        this.content.style.height = '0px';
        this.content.style.opacity = '0';
        this.content.style.transition = 'height 0.3s ease, opacity 0.3s ease';

        this.toggle.addEventListener('click', () => {
            this.toggleAccordion();
        });
    }

    open() {
        this.root.classList.add('-active');

        const height = this.content.scrollHeight;

        this.content.style.opacity = '1';
        this.content.style.height = height + 'px';

        this.content.addEventListener(
            'transitionend',
            () => {
                if (this.root.classList.contains('-active')) {
                    this.content.style.height = 'auto';
                }
            },
            { once: true }
        );

        if (this.options.scrollToOpen) {
            setTimeout(() => {
                const offset = 100;

                const elementTop =
                    this.root.getBoundingClientRect().top + window.pageYOffset;
                const offsetPosition = elementTop - offset;

                window.scrollTo({
                    top: offsetPosition,
                    behavior: 'smooth',
                });
            }, 200);
        }
    }

    close() {
        this.root.classList.remove('-active');

        const height = this.content.scrollHeight;

        this.content.style.height = height + 'px';

        requestAnimationFrame(() => {
            this.content.style.height = '0px';
            this.content.style.opacity = '0';
        });
    }

    toggleAccordion() {
        const parent = this.root.closest('[data-faq-block-cat]');

        if (!this.options.multipleOpen) {
            const accordions = parent.querySelectorAll('[data-faq]');

            accordions.forEach(el => {
                if (el !== this.root) {
                    el.classList.remove('-active');

                    const content =
                        el.querySelector(
                            '[data-faq-toggle]'
                        ).nextElementSibling;

                    content.style.height = '0px';
                    content.style.opacity = '0';
                }
            });
        }

        if (this.root.classList.contains('-active')) {
            this.close();
        } else {
            this.open();
        }
    }
}

class FaqBlock {
    constructor(el, options = {}) {
        this.options = {
            multipleOpen: false,
            openFirst: true,
            scrollToOpen: true,
            ...options,
        };

        if (!this.set(el)) return;
        this.init();
    }

    set(el) {
        if (!el) return false;

        this.root = el;
        this.tabEl = this.root.querySelectorAll('[data-faq-block-tab]');
        this.tabsWrapper = this.root.querySelector('[data-faq-block-tabs]');
        this.catEl = this.root.querySelectorAll('[data-faq-block-cat]');
        this.faqEl = this.root.querySelectorAll('[data-faq]');

        return true;
    }

    init() {
        this.initTabs();
        this.initAccordion();
        this.openFirst();
    }

    initTabs() {
        this.catEl.forEach((el, index) => {
            el.classList.toggle('-active', index === 0);
        });

        this.tabEl.forEach(tab => {
            tab.addEventListener('click', () => {
                const index = tab.dataset.faqBlockTab;

                this.switchTab(index);

                this.tabEl.forEach(t => t.classList.remove('-active'));
                tab.classList.add('-active');

                requestAnimationFrame(() => {
                    this.scrollTabIntoView(tab);
                });
            });
        });
    }

    switchTab(index) {
        this.catEl.forEach((cat, i) => {
            cat.classList.toggle('-active', i == index);
        });
    }

    scrollTabIntoView(tab) {
        if (!this.tabsWrapper) return;

        const isScrollable =
            this.tabsWrapper.scrollWidth > this.tabsWrapper.clientWidth;

        if (!isScrollable) return;

        const wrapperRect = this.tabsWrapper.getBoundingClientRect();
        const tabRect = tab.getBoundingClientRect();
        const currentScroll = this.tabsWrapper.scrollLeft;
        const targetScroll =
            currentScroll +
            (tabRect.left - wrapperRect.left) -
            (wrapperRect.width / 2 - tabRect.width / 2);

        this.tabsWrapper.scrollTo({
            left: Math.max(0, targetScroll),
            behavior: 'smooth',
        });
    }

    initAccordion() {
        this.faqEl.forEach(el => {
            new FaqAccordion(el, {
                multipleOpen: this.options.multipleOpen,
                scrollToOpen: this.options.scrollToOpen,
            });
        });
    }

    openFirst() {
        if (!this.options.openFirst) return;

        const first = this.root.querySelector('[data-faq]');
        if (!first) return;

        setTimeout(() => {
            first.querySelector('[data-faq-toggle]').click();
        }, 100);
    }
}

const sections = document.querySelectorAll('[data-faq-block]');

const setFaqBlock = sections => {
    if (!sections) return;

    sections.forEach(el => {
        new FaqBlock(el, {
            multipleOpen: true,
            openFirst: true,
            scrollToOpen: true,
        });
    });
};

setFaqBlock(sections);
